export default __webpack_public_path__ + "static/media/visa.38520e71.svg";